import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {ApiService} from '../Services/Api/api.service';
import {environment} from '../../environments/environment';
import {SessionService} from '../Services/Session/session-service.service';
import {MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.css', '../../assets/layout/style/layout.css']
})
export class AuthorizationComponent implements OnInit {
  authorizations: any = [];
  ordered: any = [];
  auth2: any = [];
  dt1: string;
  dt2: string;
  showDetail = false;
  details: any = [];
  env = environment;
  loading = false;
  rangeDates: Date[];
  firstDate: Date | undefined;
  lastDate: Date | undefined;
  titleAuthorization: string;
  subTitleAuthorization: string;
  firstMls: any;
  lastMls: any;
  cols: any = [{header: 'Estatus'}, {header: 'Descripción'}, {header: 'Carnet'}, {header: 'No. Solicitud'},
    {header: 'Nombre Completo'}, {header: this.fb.getStringRC('global_due_date')},
    {header: 'Descargar'}, {header: 'Detalles'}];
  constructor(private realm: RealmService, public fb: FirebaseService, private api: ApiService, private st: SessionService, private ms: MessageService, private router: Router) { }

  ngOnInit() {
    console.log("entra a oninit authorization");
    console.log(this.dt1 + " "+ this.dt2);
    this.realm.loginAsync().then(val => {
      this.getauth();
    });
    this.fb.fetchActivate().then(() => {
      this.getRemoteConfig();
     });
    /*
    let day = LocalDate.now().dayOfMonth().toString();
    let month = LocalDate.now().month().value().toString();
    let monthMinus = LocalDate.now().month().minus(3).value().toString();
    if (month.length < 2) {
      month = '0' + LocalDate.now().month().value().toString();
    }
    if (monthMinus.length < 2) {
      monthMinus = '0' + LocalDate.now().month().minus(3).value().toString();
    }
    if (day.length < 2) {
      day = '0' + LocalDate.now().dayOfMonth().toString();
    }
    this.dt1 = day + '/' + monthMinus + '/' + LocalDate.now().year().toString();
    this.dt2 = day + '/' + month + '/' + LocalDate.now().year().toString();*/

    const dateNow = Date.now();
    const hoy = new Date(dateNow);
    let todayDateFormat= hoy.toLocaleDateString('en-GB');

    let msThreeMonth = 183*1000*60*60*24;
    const msToday = new Date(dateNow).getTime();
    let firstRangeDefaultMs = msToday - msThreeMonth;
    const threeMonthBack = new Date(firstRangeDefaultMs);
    let firstRangeFilterDefault = threeMonthBack.toLocaleDateString('en-GB');

    this.dt1 = firstRangeFilterDefault;
    this.dt2 = todayDateFormat;


    //this.rangeDates = this.dt1 + this.dt2;
    this.loading = true;
    this.env.isContentLoading = true;
    this.api.responseAuthorization$.subscribe( data => {
      const dat = JSON.parse(JSON.stringify(data));
      
      this.authorizations = [];
      console.log(dat);
      if (dat.code === 701) {
        // @ts-ignore
        const s: any = dat.resultAuthorizations.success;
        this.auth2 = s;
        this.parseAuth(s).then( d => {
          this.loading = false;
          this.env.isContentLoading = false;
        });
        //this.authorizations = s;
        this.ordered = this.authorizations.sort((a, b) => {
          const requestA = a.detail.authorizationCompleteNumber.toUpperCase(); // ignore upper and lowercase
          const requestB = b.detail.authorizationCompleteNumber.toUpperCase(); // ignore upper and lowercase
          if (requestA > requestB) {
            return -1;
          }
          if (requestA < requestB) {
            return 1;
          }
        
          // names must be equal
          return 0;
        });
        if (s.hasOwnProperty('success')) {

        }
      } else {
        this.env.isContentLoading = false;
        this.ms.add({severity: 'error', summary: 'error', detail: this.fb.getStringRC('global_message_' + dat.code), sticky: false});
      }
    });
  }
  async parseAuth(s: any) {
    return new Promise((resolve, reject) => {
      for (let sKey in s) {
        s[sKey].detail.forEach( val => {
          this.authorizations.push({detail: val, type: s[sKey].authorizationTypeDescription, auth: s[sKey]});
        });
      }
      resolve();
    });
  }
  async getauth() {
    console.log("entra a getauth");
    this.realm.getAuthorizationSetting(this.dt1, this.dt2);
    /*
    const d = await this.st.getParam('atr');
    console.log(d);
    if (d != null && d !== '') {
      console.log("entra a if "+this.dt1 + " "+ this.dt2);
      this.authorizations = JSON.parse(d);
    } else {
      console.log("entra a else: "+this.dt1 + " "+ this.dt2);
      this.realm.getAuthorizationSetting(this.dt1, this.dt2);
    }*/
  }

  getRemoteConfig() {
    this.titleAuthorization = this.fb.getStringRC('txt_title_authorization');
    this.subTitleAuthorization = this.fb.getStringRC('txt_subtitle_authorization');
  }

  downloadPDF(n: string) {
    window.open(
      this.env.urlDocuments+"?uuid=RPN&authorization=" + n,
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  detailAuth(detail: any) {
    this.showDetail = true;
    this.details = detail;
    console.log(detail);
  }
  searchRange() {
    // seconds < 10 ? '0' + seconds : seconds;
    this.firstMls = this.firstDate?.getTime();
    this.lastMls = this.lastDate?.getTime();
    if (this.firstDate.getDate().toString().length > 0 && this.lastDate.getDate().toString()) {
      let diff = this.lastMls - this.firstMls;
      let diffDays = diff/(1000*60*60*24);
      if (diffDays < 0){
        this.ms.clear();
        this.ms.add({severity: 'error', summary: 'La fecha de inicio no puede ser mayor a la fecha final', sticky: false});
      }else{
        if (diffDays > 183) { // MAYOR A 6 MESES
          this.ms.clear();
          this.ms.add({severity: 'error', summary: 'El rango máximo permitido de búsqueda es de 6 meses', sticky: false});
        } else {
          let dd1 = this.firstDate.getDate().toString();
          let mm1 = (this.firstDate.getMonth() + 1).toString();
          if (dd1.length < 2) {
            dd1 = '0' + dd1;
          }
          if (mm1.length < 2) {
            mm1 = '0' + mm1;
          }
          let dd2 = this.lastDate.getDate().toString();
          let mm2 = (this.lastDate.getMonth() + 1).toString();
          if (dd2.length < 2) {
            dd2 = '0' + dd2;
          }
          if (mm2.length < 2) {
            mm2 = '0' + mm2;
          }
          this.dt1 = dd1 + '/' + mm1 + '/' + this.firstDate.getFullYear().toString();
          this.dt2 = dd2 + '/' + mm2 + '/' + this.lastDate.getFullYear().toString();
          this.env.isContentLoading = true;
          this.realm.getAuthorizationSetting(this.dt1, this.dt2);
        }
      }
    } else {
      this.ms.clear();
      this.ms.add({severity: 'error', summary: 'Por favor ingrese datos para realizar búsqueda', sticky: false});
    }


    
  }

  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})/, '$1/$2/');
    //console.log(event.target.value);
  }

  navigateNewAuthorization() {

    this.router.navigate(['home/new-authorization']);
    
  }

  customSort(event: SortEvent) {
    console.log("event: "+ event);
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else
            result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
    });
}
}
